import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import * as L from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { AppRooute } from 'src/app/core/common/app-route.model';
import { AppSettings } from 'src/app/core/common/app-settings';
import { RouteConstant } from 'src/app/core/common/route-constant';
import { StateConstant } from 'src/app/core/common/state-constant';
import { DesaparecidoDnaService } from 'src/app/core/services/caso/desaparecido-dna.service';
import { DesaparecidoSaludService } from 'src/app/core/services/caso/desaparecido-salud.service';
import { DesaparecidoService } from 'src/app/core/services/caso/desaparecido.service';
import { PublicacionService } from 'src/app/core/services/caso/publicacion.service';
import { DesaparecidoCompDto } from 'src/app/shared/models/caso/desaparecido-cmp-dto.model';
import { DesaparecidoSaludVo } from 'src/app/shared/models/caso/desaparecido-salud-vo.model';
import { environment } from 'src/environments/environment';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { formatDate } from '@angular/common';

@Component({
    selector: 'vex-desaparecido-form',
    templateUrl: './desaparecido-form.component.html',
    styleUrls: ['./desaparecido-form.component.scss']
})
export class DesaparecidoFormComponent implements OnInit {
    appSettings = AppSettings;
    stateConstant = StateConstant;
    crumbs: AppRooute[] = [RouteConstant.ROUTE_CASE_MISSING];

    form: FormGroup;
    formCmp: FormGroup;
    id: number;
    pageType: string;

    desaparecidoService = inject(DesaparecidoService);
    desaparecidoSaludService = inject(DesaparecidoSaludService);
    desaparecidoDnaService = inject(DesaparecidoDnaService);
    publicacionService = inject(PublicacionService);
    urlThumbnail: string;

    desaparecido: any;
    desaparecidoCmp: any;
    private map: L.Map;
    private centroid: L.LatLngExpression;

    showDna: boolean = false;
    showSalud: boolean = false;

    isDocument: boolean;
    valueToExternal: string;

    dataSource: MatTableDataSource<DesaparecidoSaludVo>;
    displayedColumns: string[] = ['atencionFecha', 'atencionHora', 'atencionCentro', 'fechaCreacion'];
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    selection = new SelectionModel<DesaparecidoSaludVo>(true, []);
    searchKey: string;

    dataSourceDna: MatTableDataSource<DesaparecidoSaludVo>;
    displayedColumnsDna: string[] = ['fechaRegistro', 'horaRegistro', 'lugarRemision', 'responsableSeguimiento', 'atencion', 'albergue', 'derivacion', 'entrega', 'fechaCreacion'];
    @ViewChild(MatSort, { static: true }) sortDna: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginatorDna: MatPaginator;
    selectionDna = new SelectionModel<DesaparecidoSaludVo>(true, []);
    dto: DesaparecidoCompDto = new DesaparecidoCompDto();

    constructor(private router: Router,
        private route: ActivatedRoute,
        private toastrService: ToastrService,
        private dialog: MatDialog,
        private fb: FormBuilder) {

        this.form = this.fb.group({
            nombres: ["", Validators.required],
            apellidoPaterno: ["", Validators.required],
            apellidoMaterno: ["", Validators.required],
            documento: ["", Validators.required],
            complemento: ["", Validators.required],
            sexo: ["", Validators.required],
            fechaNacimiento: ["", Validators.required],
            edad: ["", Validators.required],
            nacionalidad: ["", Validators.required],
            fechaDesaparicion: ["", Validators.required],
            colorOjos: ["", Validators.required],
            colorCabellos: ["", Validators.required],
            tez: ["", Validators.required],
            estatura: ["", Validators.required],
            peso: ["", Validators.required],
            vestimenta: ["", Validators.required],
            referencia: ["", Validators.required],
            gestion: ["", Validators.required],
            resumen: ["", Validators.required],
            lugarHecho: ["", Validators.required],
            departamento: ["", Validators.required],
            provincia: ["", Validators.required],
            municipio: ["", Validators.required],
            fecha_atencion: ["", Validators.required],
            horario_atencion: ["", Validators.required],
            centro_atencion: ["", Validators.required],
            fecha: ["", Validators.required],
            hora_registro: ["", Validators.required],
            lugar_remision: ["", Validators.required],
            responsable_seguimiento: ["", Validators.required],
            atencion: ["", Validators.required],
            albergue: ["", Validators.required],
            derivacion: ["", Validators.required],
            entrega: ["", Validators.required]
        });
        // Datos complementarios
        this.formCmp = this.fb.group({
            numoriginal: [""],
            fecha_ingreso: [""],
            hora_ingreso: [""],
            nro_registro: [""],
            codigo: [""],
            folio: [""],
            distrito: [""],
            macrodistrito: [""],
            observacion: [""],
            descripcion_aparicion: [""],
            tiempo_desaparicion: [""],
            zona: [""],
            direccion: [""],
            policia_complemento: [""],
            orden: [""],
            estado: [""],
            fecha_recepcion: [""]
        });
    }

    ngOnInit(): void {
        this.id = this.route.snapshot.params.id;
        // Caso y servicios
        this.desaparecidoService.findById(this.id)
            .subscribe(
                response => {
                    this.desaparecido = response.data;
                    this.form.controls['nombres'].setValue(response.data.nombres);
                    this.form.controls['apellidoPaterno'].setValue(response.data.apellidoPaterno);
                    this.form.controls['apellidoMaterno'].setValue(response.data.apellidoMaterno);
                    this.form.controls['documento'].setValue(response.data.documento);
                    this.form.controls['complemento'].setValue(response.data.complemento);
                    this.form.controls['sexo'].setValue(response.data.sexo);
                    this.form.controls['fechaNacimiento'].setValue(this.formatDates(response.data.fechaNacimiento));
                    this.form.controls['edad'].setValue(response.data.edad + 'años');
                    this.form.controls['nacionalidad'].setValue(response.data.nacionalidad);
                    this.form.controls['fechaDesaparicion'].setValue(this.hformatDates(response.data.fechaDesaparicion));
                    this.form.controls['colorOjos'].setValue(response.data.colorOjos);
                    this.form.controls['colorCabellos'].setValue(response.data.colorCabellos);
                    this.form.controls['tez'].setValue(response.data.tez);
                    this.form.controls['estatura'].setValue(response.data.estatura);
                    this.form.controls['peso'].setValue(response.data.peso);
                    this.form.controls['vestimenta'].setValue(response.data.vestimenta);
                    this.form.controls['referencia'].setValue(response.data.referencia);
                    this.form.controls['gestion'].setValue(response.data.gestion);
                    this.form.controls['resumen'].setValue(response.data.resumen);
                    this.form.controls['lugarHecho'].setValue(response.data.lugarHecho);
                    this.form.controls['departamento'].setValue(response.data.departamento);
                    this.form.controls['provincia'].setValue(response.data.provincia);
                    this.form.controls['municipio'].setValue(response.data.municipio);
                    this.urlThumbnail = response.data.urlPhoto;
                    if (response.data.documento !== undefined) {
                        this.isDocument = true;
                        this.valueToExternal = response.data.documento + response.data.complemento;
                    } else {
                        this.isDocument = false;
                        this.valueToExternal = response.data.nombres + ' ' + response.data.apellidoPaterno + ' ' + response.data.apellidoMaterno;
                    }
                    this.initMap();
                    this.desaparecidoSaludService.findAll(this.id).subscribe(responseSalud => {
                        if (responseSalud.data.length > 0) {
                            this.showSalud = true;
                            this.dataSource = new MatTableDataSource(responseSalud.data);
                            this.dataSource.paginator = this.paginator;
                            this.dataSource.sort = this.sort;
                        }
                    });
                    this.desaparecidoDnaService.findAll(this.id).subscribe(responseDna => {
                        if (responseDna.data[0] !== undefined) {
                            this.showDna = true;
                            this.dataSourceDna = new MatTableDataSource(responseDna.data);
                            this.dataSourceDna.paginator = this.paginatorDna;
                            this.dataSourceDna.sort = this.sortDna;
                        }
                    });
                },
                err => {
                    console.error('Código del error desde el backend: ' + err.status);
                    console.error(err.error.errors);
                }
            );
        // complementarios    
        this.desaparecidoService.findCmpById(this.id)
            .subscribe(
                response => {
                    this.desaparecidoCmp = response.data;
                    this.formCmp.controls['numoriginal'].setValue(response.data.numoriginal);
                    this.formCmp.controls['fecha_ingreso'].setValue(response.data.fecha_ingreso);
                    this.formCmp.controls['hora_ingreso'].setValue(response.data.hora_ingreso);
                    this.formCmp.controls['nro_registro'].setValue(response.data.nro_registro);
                    this.formCmp.controls['codigo'].setValue(response.data.codigo);
                    this.formCmp.controls['folio'].setValue(response.data.folio);
                    this.formCmp.controls['distrito'].setValue(response.data.distrito);
                    this.formCmp.controls['macrodistrito'].setValue(response.data.macrodistrito);
                    this.formCmp.controls['observacion'].setValue(response.data.observacion);
                    this.formCmp.controls['descripcion_aparicion'].setValue(response.data.descripcion_aparicion);
                    this.formCmp.controls['tiempo_desaparicion'].setValue(response.data.tiempo_desaparicion);
                    this.formCmp.controls['zona'].setValue(response.data.zona);
                    this.formCmp.controls['direccion'].setValue(response.data.direccion);
                    this.formCmp.controls['policia_complemento'].setValue(response.data.policia_complemento);
                    this.formCmp.controls['orden'].setValue(response.data.orden);
                    this.formCmp.controls['estado'].setValue(response.data.estado);
                    this.formCmp.controls['fecha_recepcion'].setValue(response.data.fecha_recepcion);
                },
                err => {
                    console.error('Código del error desde el backend: ' + err.status);
                    console.error(err.error.errors);
                }
            );
    }

    save() {
        this.dto.numoriginal = this.formCmp.value.numoriginal;
        this.dto.fecha_ingreso = this.formCmp.value.fecha_ingreso;
        this.dto.hora_ingreso = this.formCmp.value.hora_ingreso;
        this.dto.nro_registro = this.formCmp.value.nro_registro;
        this.dto.codigo = this.formCmp.value.codigo;
        this.dto.folio = this.formCmp.value.folio;
        this.dto.distrito = this.formCmp.value.distrito;
        this.dto.macrodistrito = this.formCmp.value.macrodistrito;
        this.dto.observacion = this.formCmp.value.observacion;
        this.dto.descripcion_aparicion = this.formCmp.value.descripcion_aparicion;
        this.dto.tiempo_desaparicion = this.formCmp.value.tiempo_desaparicion;
        this.dto.zona = this.formCmp.value.zona;
        this.dto.direccion = this.formCmp.value.direccion;
        this.dto.policia_complemento = this.formCmp.value.policia_complemento;
        this.dto.orden = this.formCmp.value.orden;
        this.dto.estado = this.formCmp.value.estado;
        this.dto.fecha_recepcion = this.formCmp.value.fecha_recepcion;

        this.desaparecidoService.update(this.id, this.dto).subscribe(response => {
            if (response.status) {
                this.toastrService.success(response.message);
                //this.router.navigate([`./${RouteConstant.ROUTE_CASE_GRUPO.url}`]);
            } else
                this.toastrService.warning(response.message);
        });
    }

    nothing() {

    }

    hformatDates(myDate: any) {
        const format = 'dd/MM/yyyy HH:mm';
        //const myDate = '2019-06-29';
        const date = new Date(myDate);
        const locale = 'en-US';
        return formatDate(date, format, locale);
    }

    formatDates(myDate: any) {
        const format = 'dd/MM/yyyy';
        //const myDate = '2019-06-29';
        const date = new Date(myDate);
        const locale = 'en-US';
        return formatDate(date, format, locale);
    }

    foto(): string {
        return environment.apiSecurityUrl + 'api/v1/util/stream/fotos/' + this.id;
    }

    publicar() {
        this.dialog
            .open(ConfirmDialogComponent, {
                data: new ConfirmDialogModel("Cambiar publicado", "¿Está seguro de cambiar el estado de publicado?")
            })
            .afterClosed()
            .subscribe((confirmado: Boolean) => {
                if (confirmado) {
                    this.publicacionService.cambiarPublicadoByDesaparecido(this.id).subscribe(
                        response => {
                            if (response.status) {
                                this.toastrService.success(response.message);
                            } else {
                                this.toastrService.warning(response.message);
                            }
                        },
                        err => {
                            this.toastrService.error(err.data);
                        }
                    )
                }
            });
    }

    downloadPdf() {
        window.open(this.desaparecido.urlPdfReport, '_blank');
    }

    downloadImage() {
        window.open(this.desaparecido.urlPdfImageReport, '_blank');
    }

    initMap() {
        this.centroid = [this.desaparecido.latitud, this.desaparecido.longitud];
        this.map = L.map('map', {
            center: this.centroid,
            zoom: 14
        });

        const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            minZoom: 10,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        });
        tiles.addTo(this.map);
        const marker = L.marker(this.centroid);
        marker.addTo(this.map);
    }
}